import { Zap } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { MOCK_AIFX_EXCHANGE_HISTORY } from "@/lib/mockData";
import { C } from "./profileTheme";
import { useTranslation } from "react-i18next";
import { getTokenName, INTEGRAL_COIN_CONTRACT } from "@/config/common";
import { CCC_AIF_ADDRESS } from "@/config/env";

export function AifxHistoryDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-sm mx-auto"
        style={{
          background: "#0d0f14",
          border: "1px solid rgba(34,197,94,0.20)",
          color: C.text,
        }}
      >
        <DialogHeader>
          <DialogTitle style={{ color: C.primary }}>
            {t("profilePage.aifxHistoryDialog.title", {
              tokenNameAifx: getTokenName(INTEGRAL_COIN_CONTRACT),
            })}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {MOCK_AIFX_EXCHANGE_HISTORY &&
          MOCK_AIFX_EXCHANGE_HISTORY.length > 0 ? (
            MOCK_AIFX_EXCHANGE_HISTORY.map(ex => (
              <div
                key={ex.id}
                className="rounded-lg p-3"
                style={{
                  background: C.card,
                  border: `1px solid ${C.border}`,
                }}
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <Zap size={13} style={{ color: C.amber }} />
                    <span className="text-sm font-semibold">
                      {t("profilePage.aifxHistoryDialog.exchangeSuccess")}
                    </span>
                  </div>
                  <span
                    className="text-[10px] px-2 py-0.5 rounded"
                    style={{
                      background: "rgba(34,197,94,0.08)",
                      color: C.green,
                    }}
                  >
                    {ex.status}
                  </span>
                </div>
                <div className="space-y-1 text-xs">
                  <div className="flex justify-between">
                    <span style={{ color: C.dim }}>
                      {t("profilePage.aifxHistoryDialog.aifxDeducted", {
                        tokenNameAifx: getTokenName(INTEGRAL_COIN_CONTRACT),
                      })}
                    </span>
                    <span className="mono-num" style={{ color: C.red }}>
                      -{ex.aifxAmount}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span style={{ color: C.dim }}>
                      {t("profilePage.aifxHistoryDialog.aifReceived", {
                        tokenNameAif: getTokenName(CCC_AIF_ADDRESS),
                      })}
                    </span>
                    <span className="mono-num" style={{ color: C.green }}>
                      +{ex.aifAmount}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span style={{ color: C.dim }}>
                      {t("profilePage.aifxHistoryDialog.time")}
                    </span>
                    <span className="mono-num" style={{ color: C.dim }}>
                      {ex.time}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-xs" style={{ color: C.dim }}>
              {t("profilePage.aifxHistoryDialog.empty")}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
